import { pxToRem } from '../../../../utils/index';
export var toolbarStyles = {
  root: function root() {
    return {
      display: 'flex',
      alignItems: 'center',
      position: 'relative'
    };
  },
  offsetMeasure: function offsetMeasure() {
    return {
      position: 'absolute',
      visibility: 'hidden',
      left: 0,
      top: 0
    };
  },
  overflowContainer: function overflowContainer() {
    return {
      display: 'flex',
      overflow: 'hidden',
      flexGrow: 1
    };
  },
  overflowSentinel: function overflowSentinel(_ref) {
    var props = _ref.props;
    return {
      width: pxToRem(100),
      display: props.overflowOpen ? 'block' : 'none',
      visibility: 'hidden'
    };
  }
};